export const getEnv = () => {
    const { VITE_DEPLOY_ENV, PUBLIC_DEPLOY_ENV, DEPLOY_ENV, } = import.meta.env;
    return VITE_DEPLOY_ENV ?? PUBLIC_DEPLOY_ENV ?? DEPLOY_ENV;
};
export const getCookieDomain = () => {
    const env = getEnv();
    return env === "local"
        ? ".mapka.localhost"
        : env === "dev"
            ? ".dev.mapka.dev"
            : ".mapka.dev";
};
//# sourceMappingURL=env.js.map